import React from 'react';
import Select, { components } from 'react-select';

const { ValueContainer, Placeholder }: any = components;

const CustomValueContainer: React.FC<any> = ({ children, ...props }) => {
    return (
        <ValueContainer {...props}>
            <Placeholder {...props} isFocused={props.isFocused}>
                {props.selectProps.placeholder}
            </Placeholder>
            {React.Children.map(children, (child) =>
                child && child.type !== Placeholder ? child : null
            )}
        </ValueContainer>
    );
};

type selectProps = {
    options?: any[],
    placeholder?: string,
    name?: string,
    onChange?: any,
    isSearchable?: boolean,
    isDisabled?: boolean,
    required?: boolean,
    value?: any,
    onBlur?: any,
    tabIndex?: any,
}

const SelectField: React.FC<selectProps> = ({ options, placeholder, name, onChange, isSearchable, isDisabled, required, value, onBlur, tabIndex }) => {

    return (
        <Select
            className="select-form"
            name={name}
            id={name}
            options={options}
            components={{
                ValueContainer: CustomValueContainer
            }}
            isSearchable={isSearchable}
            isDisabled={isDisabled}
            value={value}
            placeholder={`${placeholder} ${required ? '*' : ''}`}
            onChange={onChange}
            onBlur={onBlur}
            tabIndex={tabIndex}

            styles={{
                valueContainer: (provided, state) => ({
                    ...provided,
                    overflow: "visible"
                }) as any,
                placeholder: (provided, state) => ({
                    ...provided,
                    position: "absolute",
                    paddingRight: 3,
                    paddingLeft: 3,
                    top: state.hasValue || state.selectProps.inputValue ? -11 : "13%",
                    backgroundColor:
                        state.hasValue || state.selectProps.inputValue
                            ? "white"
                            : "transparent",
                    transition: "top 0.3s, font-size 0.3s",
                    fontSize: (state.hasValue || state.selectProps.inputValue) && 12
                }) as any
            }}
        />
    )
}


export default SelectField
